import { z } from 'zod'
import { dateValueSchema } from './date-value'

/**
 * 更新資料 共同欄位 - Schema
 */
export const commonUpdateDataSchema = z.object({
  /** 更新日期 */
  updateTime: dateValueSchema.optional(),
  /** 更新人員 */
  updateBy: z.string().optional()
})

/**
 * 更新資料 共同欄位
 */
export interface CommonUpdateData
  extends z.infer<typeof commonUpdateDataSchema> {}
